import formatAssetNameForSelect from '../../utils/formatAssetName';

const resultLabel = result => {
  switch(result?.__typename) {
    case 'Asset':
      return `${result.vin} | ${result.stockNumber} | ${result.seller?.name} | ${formatAssetNameForSelect(result)}`;
    case 'InputOption':
      return result.label;
    case 'User':
      return result.fullName;
    default:
      return '';
  }
};

export default resultLabel;
